export default __webpack_public_path__ + "static/media/D-verse_Logo.10f952b7.png";